import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone, FaHeart } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: FaGithub,
      href: 'https://github.com/devthyrso',
      label: 'GitHub',
    },
    {
      icon: FaLinkedin,
      href: 'https://linkedin.com/in/pedro-thyrso',
      label: 'LinkedIn',
    },
    {
      icon: FaEnvelope,
      href: 'mailto:dev.thyrso@gmail.com',
      label: 'Email',
    },
    {
      icon: FaPhone,
      href: 'tel:+5514996825201',
      label: 'Phone',
    },
  ];

  return (
    <footer className="py-12 relative border-t border-gray-800 mb-0 pb-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center space-y-6">
          {/* Logo/Name */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h3 className="text-2xl font-bold text-blue-500 mb-2">Pedro Thyrso</h3>
            <p className="text-gray-400">Full Stack Developer</p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex space-x-6"
          >
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  whileHover={{ scale: 1.2, y: -3 }}
                  whileTap={{ scale: 0.9 }}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  <Icon className="text-2xl" />
                </motion.a>
              );
            })}
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex flex-wrap justify-center gap-6 text-sm"
          >
            <a href="#home" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
              {t('nav.home')}
            </a>
            <a href="#about" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
              {t('nav.about')}
            </a>
            <a href="#skills" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
              {t('nav.skills')}
            </a>
            <a href="#experience" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
              {t('nav.experience')}
            </a>
            <a href="#projects" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
              {t('nav.projects')}
            </a>
            <a href="#contact" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
              {t('nav.contact')}
            </a>
          </motion.div>

          {/* Divider */}
          <div className="w-full max-w-md h-px bg-gray-800"></div>

          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="text-center text-gray-500 text-sm"
          >
            <p className="flex items-center justify-center">
              {t('footer.madeWith')} <FaHeart className="text-red-500 mx-1" /> {t('footer.by')}
            </p>
            <p className="mt-2">© {currentYear} Pedro Thyrso. {t('footer.rights')}</p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
